<template>
    <div v-if="ready">
        <!-- S: PC -->
        <div v-if="!$vuetify.breakpoint.mobile">
            <v-data-table :items="reviews" :headers="reviewsHeaders" disable-sort hide-default-footer class="v-data-table--default">
                <v-rating slot="item.rating" slot-scope="{item}" :value="item.rating" color="yellow darken-1" background-color="grey" length="5" size="20" dense readonly />
                <template slot="item.writer" slot-scope="{item}">{{ item.writer.name }}</template>
                <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                <template slot="item.actions" slot-scope="{item}">
                    <div v-if="item._member == payload?._user" class="v-btn--group--x-small">
                        <v-btn @click="edit(item)" x-small color="secondary">수정</v-btn>
                        <v-btn @click="remove(item)" x-small outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">삭제</span></v-btn>
                    </div>
                </template>
            </v-data-table>
        </div>
        <!-- E: PC -->

        <!-- S: 모바일 -->
        <div v-else>
            <v-divider class="grey darken-4"/>
            <template v-for="review, index in reviews">
                <v-divider v-if="index" :key="`divider${review._id}`" class="grey lighten-1"/>
                <div :key="`title${review._id}`" class="pa-12px py-md-14px">
                    <v-row no-gutters align="center" class="font-size-14 font-size-md-16">
                        <v-col cols="auto">
                            <v-rating :value="review.rating" color="yellow darken-1" background-color="grey" length="5" size="16" dense readonly />
                        </v-col>
                        <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                        <v-col cols="auto">
                            <span>{{ $dayjs(review.createdAt).format("YYYY-MM-DD") }}</span>
                        </v-col>
                        <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                        <v-col cols="auto">
                            <span>{{ review.writer.name }}</span>
                        </v-col>
                    </v-row>
                </div>

                <div :key="`content${review._id}`" class="pa-12px py-md-14px grey lighten-4">
                    <span class="font-size-14 font-size-md-16">{{ review.content }}</span>
                    <div v-if="review._member == payload?._user" class="mt-10px">
                        <div class="v-btn--group--x-small">
                            <v-btn @click="edit(review)" x-small color="secondary">수정</v-btn>
                            <v-btn @click="remove(review)" x-small outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">삭제</span></v-btn>
                        </div>
                    </div>
                </div>
            </template>
            <v-divider class="grey lighten-1"/>
        </div>
        <!-- E: 모바일 -->

        <div class="mt-20px mt-md-30px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search" />
        </div>
        <v-dialog v-model="dialog" max-width="500" content-class="rounded-0">
            <v-card elevation="0">
                <div class="pa-16px">
                    <div class="tit-wrap mb-16px">
                        <h3 class="tit tit--xs">리뷰</h3>
                    </div>

                    <div>
                        <v-textarea v-model="review.content" placeholder="리뷰" persistent-placeholder outlined hide-details rows="8" />
                    </div>

                    <div class="pt-16px">
                        <v-row class="row--x-small">
                            <v-spacer/>
                            <v-col cols="auto">
                                <v-row class="row--x-small">
                                    <v-col cols="auto">
                                        <v-btn @click="dialog = false" outlined color="grey"><span class="grey--text text--darken-3">취소</span></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn @click="save" color="primary">리뷰</v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <login-dialog ref="loginDialog" />
    </div>
</template>
<script>
import api from "@/api";
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    props: {
        product: Object
    },
    components: {
        LoginDialog
    },
    data(){
        return {
            ready: false,

            dialog: false,

            page: 1,
            pageCount: 0,
            limit: 5,

            reviews: [],
            review: {},
            reviewsHeaders: [
                { text: "후기점수", value: "rating", align: "center", width: "16%" },
                { text: "상품후기", value: "content", align: "center", width: "46%" },
                { text: "작성자", value: "writer", align: "center", width: "14%" },
                { text: "작성일자", value: "createdAt", align: "center", width: "14%" },
                { text: "-", align: "center",  value: "actions", width: "10%" },
            ]
        }
    },
    mounted(){
        this.search();
    },
    methods: {
        async search(){
            let { summary, reviews } = await api.v1.shop.products.reviews.gets(this.product._id, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            });
            this.reviews = reviews;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);

            this.ready = true;
        },

        validate(){
            try{
                if(!this.review.content) throw new Error("상품문의 내용을 작성해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },

        edit(review){
            this.review = { ...review };
            console.log(this.review)
            this.dialog = true;
        },

        async save(){
            if(this.validate() && confirm("리뷰를 등록하시겠습니까?")){
                this.login().then(async () => {
                    await api.v1.shop.products.reviews.put(this.product._id, this.review)
                    alert("리뷰가 등록되었습니다")
                    this.dialog = false;
                    this.search();
                });
            }
        },

        async remove(review){
            if(confirm("구매후기를 삭제하시겠습니까?")){
                await api.v1.shop.products.reviews.delete(this.product._id, review);
                alert("구매후기가 삭제되었습니다");
                this.search();
            }
        }
    },
    computed: {
        logon(){ return !!this.$store.state.accessToken },
        payload(){ return this.$store.state.payload; }
    }
}
</script>